import { navigateWindowTo } from '@ratehub/base-ui';


/**
 * Opens the Ratehub card details page or the provider’s own page in a new window based on if
 * the card is monetized.
 * @param {object} params - arg object
 * @param {boolean} params.isMonetized - is the card monetized?
 * @param {string} params.applyRedirectURL - the card’s apply redirect URL
 * @param {string} params.detailsURL - the card’s details URL
 * @param {string} params.applyRedirectURLOverride - optional URL for overriding typical URL
 * @param {string} params.queryParams - other parameters
 * @returns {void}
 */
function navigateNewTabToMoreDetails({
    isMonetized,
    applyRedirectURL,
    detailsURL,
    applyRedirectURLOverride,
    queryParams,
}) {
    navigateWindowTo(
        isMonetized
            ? applyRedirectURLOverride ?? applyRedirectURL
            : applyRedirectURLOverride ?? detailsURL,
        {
            isNewTab: true,
            queryParams,
        },
    );
}

export default navigateNewTabToMoreDetails;
